import { object, boolean } from 'yup';

import { yupFile } from '@utils/yup';

import { FormValues } from './type';

export const useInitialValues = () => {
  const values: FormValues = {
    agree: false,
    proof: undefined,
  }
  return values;
};

export const useValidationSchema = () => {
  return object({
    agree: boolean().oneOf([true], 'You must agree'),
    proof: yupFile(),
  });
};
